import { Organization } from '../Organization/definitions';
import { Account } from '../Account';

export const CLIENT_ENTITY_NAME = 'clients';

export interface Client {
  id: string;
  phoneNumber: string;
  jobTitle?: string;
  account: Account;
  accountId: string;
  ownedOrganizations: Organization[];
  organizations: Organization[];
  hasAllowedCalendarSync?: boolean;
}

export interface ClientCreation {
  account: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  };
  organization: {
    name: string;
    billingMethod?: string;
  };
  phoneNumber: string;
  jobTitle: string;
  promoCode?: string;
}

export interface ClientWithInvitationCreation {
  account: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  };
  phoneNumber: string;
  invitationToken: string;
  jobTitle: string;
}

export interface ClientEntities {
  clients: {
    [id: string]: Client;
  };
}
